import { useMemo } from 'react';
import { Card } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

import dateFormat from 'dateformat';

import { ExportToCSVButton } from '@components/Buttons';
import { BootstrapGenericTable } from '@components/Table';

const renderIPCell = ({ row }) => (
  <>
    {row.original.src_ip}
    <br />
    {row.original.dst_ip}
  </>
);

export const CdrsReportTable = ({ useData }) => {
  const [searchParams, _] = useSearchParams();
  const country = searchParams.get('country');

  const area = country ? searchParams.get('area') : null;
  const startDate = searchParams.get('startDate');
  const startDateTime = searchParams.get('startDateTime');
  const endDate = searchParams.get('endDate');
  const endDateTime = searchParams.get('endDateTime');
  const completed = searchParams.get('completed');
  const trafficType = searchParams.get('trafficType');
  const destination = searchParams.get('destination');

  const formatDate = (value, time = null) => {
    if (!value) {
      return null;
    }
    let dateValue = value;
    if (time) {
      dateValue = `${value}T${time}Z`;
    }
    const date = new Date(dateValue);
    return dateFormat(date, 'filterDateTimeUTC');
  };
  const filterData = {
    country,
    area,
    start_time: formatDate(startDate, startDateTime),
    end_time: formatDate(endDate, endDateTime),
    realized: completed,
    traffic_type: trafficType,
    destination,
  };

  const exportContent = () => (
    <ExportToCSVButton
      to="customer/reports/pcdrs/export"
      filterData={filterData}
    />
  );

  const columns = useMemo(
    () => [
      {
        Header: 'Start time (UTC)',
        accessor: 'start_time',
        Cell: ({ value }) => {
          const date = new Date(value);
          return dateFormat(date, 'defaultDateTimeUTC');
        },
        setMinWidth: '90px',
      },
      {
        id: 'country',
        Header: 'Country',
        accessor: 'country.name',
      },
      {
        id: 'area',
        Header: 'Area',
        accessor: 'area.name',
      },
      {
        Header: 'Destination',
        accessor: 'destination.name',
        className: 'col-md-1',
      },
      {
        Header: 'A',
        accessor: 'number_a',
        className: 'col-md-1',
      },
      {
        Header: 'B',
        accessor: 'number_b',
        className: 'col-md-1',
      },
      { Header: 'Related DID', accessor: 'related_did', className: 'col-md-1' },
      {
        Header: 'Source IP\nDestination IP',
        accessor: 'ip',
        className: 'col-md-1',
        Cell: renderIPCell,
      },
      {
        Header: 'Duration',
        accessor: 'duration',
        className: 'col-md-1',
      },
      {
        Header: 'Billable duration',
        accessor: 'rounded_up_duration',
        className: 'col-md-1',
      },
      {
        Header: 'Completed',
        accessor: 'realized',
        className: 'col-md-1',
      },
      {
        Header: 'Call cost',
        accessor: 'price',
        className: 'col-md-1',
      },
      {
        id: 'trafficType',
        Header: 'Type',
        accessor: 'traffic_type',
        className: 'col-md-1',
      },
    ],
    []
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">CDRS Report</Card.Header>
      <Card.Body>
        <BootstrapGenericTable
          columns={columns}
          useData={useData}
          filterData={filterData}
          tableProps={() => ({
            responsive: true,
            bordered: true,
            className: 'normalFontSize',
          })}
          paginated
          exportContent={exportContent}
        />
      </Card.Body>
    </Card>
  );
};
